import { lightTheme } from '@/customTheme'

/**
 * Email validation regex
 */
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

/**
 * Get base input styles for sign-in forms
 */
export const getInputStyles = (options: {
  hasError?: boolean
  isDisabled?: boolean
}) => {
  const { hasError = false, isDisabled = false } = options
  
  return {
    width: '100%',
    height: '48px',
    padding: '16px 12px',
    background: lightTheme.colors.white,
    border: `1px solid ${hasError ? lightTheme.colors.primary : lightTheme.colors.grayScale100}`,
    borderRadius: '8px',
    ...lightTheme.typography.Small14regular,
    color: isDisabled ? lightTheme.colors.text.text_200_disable : lightTheme.colors.blackGray,
    fontWeight: 400,
    transition: 'border-color 0.2s ease',
    outline: 'none',
    '::placeholder': {
      color: lightTheme.colors.grayScale400,
    },
    ':hover': {
      borderColor: lightTheme.colors.grayScale300,
    },
    ':focus': {
      borderColor: lightTheme.colors.blackGray,
    },
    pointerEvents: isDisabled ? 'none' : 'auto',
  }
}

/**
 * Common error message styles
 */
export const errorMessageStyles = {
  marginBottom: '12px',
  marginTop: '4px',
  ...lightTheme.typography.Small11medium,
  color: lightTheme.colors.primary,
  fontWeight: 400,
  textAlign: 'left' as const,
}
